import React, { useState } from "react";
import { useDeal } from "../lib/store";
import * as m from "../lib/model";
import { Building2, Repeat, ArrowRight, Plus } from "lucide-react";

export function DealKindPicker() {
  const { M, platforms, startRecap, navigate, patch } = useDeal();
  const recap = m.isRecap(M);
  const [pid, setPid] = useState(M.platformId || platforms[0]?.id || "");
  const P = platforms.find((p) => p.id === (pid || M.platformId));
  const current = recap ? platforms.find((p) => p.id === M.platformId || p.id === (M.recap || {}).platformId) : null;

  return (
    <div className="dk-picker" data-testid="deal-kind-picker">
      <div className="dk-head">What are we underwriting?</div>
      <div className="dk-options">
        <button className={`dk-opt ${!recap ? "active" : ""}`} onClick={() => recap && patch({ txnType: "acquisition", platformRole: "standalone", platformId: null, ...(M.acqAskPrice ? { askPrice: M.acqAskPrice } : {}) })} data-testid="dk-acquisition">
          <Building2 size={16} />
          <span><b>New acquisition</b><small>A target we don't own yet — upload the CIM, financials or tax returns and the model fills in.</small></span>
        </button>
        <div className={`dk-opt dk-recap ${recap ? "active" : ""}`} data-testid="dk-recap">
          <Repeat size={16} />
          <span>
            <b>Recapitalize a platform we already own</b>
            <small>{current ? `Modeling the recap of ${current.name} — upload its latest financials to refresh EBITDA and revenue.` : "Pick one of our platforms; its EBITDA, debt and multiple seed the recap model, then upload its latest numbers."}</small>
            {!current && platforms.length > 0 && (
              <span className="dk-row">
                <select className="inp" value={pid} onChange={(e) => setPid(e.target.value)} data-testid="dk-platform-select">
                  {platforms.map((p) => <option key={p.id} value={p.id}>{p.name} — EBITDA {m.fmt$(p.ebitda)}</option>)}
                </select>
                <button className="btn btn-primary btn-sm" disabled={!P} onClick={() => P && startRecap(P, {}, "upload")} data-testid="dk-start-recap"><Repeat size={12} />Start recap</button>
              </span>
            )}
            {!current && platforms.length === 0 && (
              <span className="dk-row"><button className="link-btn lime" onClick={() => navigate("firm")} data-testid="dk-goto-firm"><Plus size={10} /> Add a platform in Firm Profile first</button></span>
            )}
            {current && (
              <span className="dk-row">
                <span className="tag">Platform · {current.name}</span>
                <button className="link-btn lime" onClick={() => navigate("assumptions")} data-testid="dk-goto-recap-terms">Set recap terms <ArrowRight size={10} /></button>
              </span>
            )}
          </span>
        </div>
      </div>
    </div>
  );
}
